import React, { useEffect, useRef, useState, IonLoading } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { Helmet } from 'react-helmet';
import { ApiService } from '../../containers/Services/apiservice';
let apiServices = new ApiService();
const Contact = () => {
  const [pageContent, setPageContent] = useState('');
  const [pageTitle, setPageTitle] = useState('');
  const [pageKeywords, setPageKeywords] = useState('');
  const [pageDescription, setPageDescription] = useState('');
  const [footer4, setfooter4] = useState('')
  const [facebook, setFacebook] = useState('')
  const [twitter, setTwitter] = useState('')
  const [linkedin, setLinkedin] = useState('')
  const [instagram, setInstagram] = useState('')
  const [youtube, setYoutube] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [newholderData, setnewholderData] = useState({ user_name: '', user_email: '', user_subject: '', user_message: '' });
  const didMountRef = useRef(true);
  useEffect(() => {
    if (didMountRef.current) {
      const dataString = {
        "url": 'contact'
      }
      apiServices.footerGetRequest().then(res => {
        if (res.data.status == 'success') {
          // setEmail(res.data.data.gs_email);
          // setAddress(res.data.data.gs_address);
          setFacebook(res.data.data.gs_facebook_url);
          setTwitter(res.data.data.gs_twitter_url);
          setLinkedin(res.data.data.gs_linkedin_url);
          setInstagram(res.data.data.gs_instagram_url);
          setYoutube(res.data.data.gs_youtube_url);
        }
      })
      apiServices.pagesPostRequest(dataString).then(res => {
        if (res.data.status == 'success') {
          setPageContent(res.data.data.page_content);
          setPageTitle(res.data.data.page_name);
          setPageKeywords(res.data.data.page_meta_keyword);
          setPageDescription(res.data.data.page_meta_desc);
        }
      })
        .catch(error => {
        })
      apiServices.getfooterdata().then(res => {
        if (res.data.status == 'success') {
          setfooter4(res.data.data.footer_desc4)
        }
      })
      return;
    }
    didMountRef.current = false;
  })
  const click = () => {
   if (newholderData.user_name == '') {
      setErrorMessage("Name is Required");
      return false
    }
    else if (newholderData.user_email == '') {
      setErrorMessage("Email is Required");
      return false
    }
    else if (newholderData.user_subject == '') {
      setErrorMessage("Subject is Required");
      return false
    }
    else if (newholderData.user_message == '') {
      setErrorMessage("Message is Required");
      return false
    } else {
      setErrorMessage('')
    }
    const dataString2 = {
      "contact_email": newholderData.user_email,
      "contact_subject": newholderData.user_subject,
      "contact_message": newholderData.user_message,
      "contact_name": newholderData.user_name
    }
    apiServices.savecontactdata(dataString2).then(res => {
      if (res.data.status == 'success') {
        alert("Your Response hasbeen Save")
        window.location.reload()
      }
    })
  }
  const handleSecondHolderata = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setnewholderData({ ...newholderData, [key]: value })
  }
  return (
    <div>
      <Header />
      <Helmet>
        <title>{pageTitle} - Goalstox</title>
        <meta name="keywords" content={pageKeywords} />
        <meta name="description" content={pageDescription} />
      </Helmet>
      {/* <span dangerouslySetInnerHTML={{ __html: pageContent }} ></span> */}
      <div class="subheader" style={{ backgroundImage: "url(/img/bg.jpg)" }}>
        {/* style="backgroundImage: url(img/bg.jpg);" */}
        <div className="container-fluid">
          <div className="row tx-center">
            <div className="col-md-12">
              <h1>Contact Us</h1>
              <div className="page-breadcrumb">
                <ul className="breadcrumb">
                  <li><Link to="/">Home</Link></li>
                  <li className="active"><span>Contact Us</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row mg-t-20">
          <div className="col-lg-7">
            <h1>Get In Touch</h1>
            <p>  If you have any questions or enquiries please feel free to contact us
              alternatively you can complete our online enquiry form located below and
              we will get back to you as soon as possible.</p>
            <div className="form-group"><label>Full Name</label>
              <input type="text" name="user_name" className="form-control" placeholder="" value={newholderData.user_name} onChange={handleSecondHolderata} />
            </div><div class="form-group">
              <label className="mg-b-0-f">Email</label>
              <input type="email" name="user_email" className="form-control" placeholder="" value={newholderData.user_email} onChange={handleSecondHolderata} />
            </div>
            <div className="form-group"><label>Subject</label>
              <input type="text" name="user_subject" className="form-control" placeholder="" value={newholderData.user_subject} onChange={handleSecondHolderata} />
            </div>
            <div className="form-group"><label>Message</label>
              <textarea rows="4" cols="60" name="user_message" value={newholderData.user_message} onChange={handleSecondHolderata}></textarea>
            </div>
            {
              errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
            }
            <button className="btn btn-success button01" onClick={click}>Send Message</button>
          </div>
          <div className="col-lg-5">
            <h1>Contact Info</h1>
            <hr />
            <div className="footer-list" dangerouslySetInnerHTML={{ __html: footer4 }}>
            </div>
            <hr></hr>
            <div className="social-footer">
              <ul>
                {
                  facebook != null ? <li>
                    <a href={facebook} target="new"><i className="fa fa-facebook" aria-hidden="true"></i></a>
                  </li> : null
                }
                {
                  twitter != null ? <li>
                    <a href={twitter}><i className="fa fa-twitter" aria-hidden="true"></i></a>
                  </li> : null
                }
                {
                  linkedin != null ? <li>
                    <a href={linkedin}><i className="fa fa-linkedin" aria-hidden="true"></i></a>
                  </li> : null
                }
                {
                  instagram != null ? <li>
                    <a href={instagram}><i className="fa fa-instagram" aria-hidden="true"></i></a>
                  </li> : null
                }
                {
                  youtube != null ? <li>
                    <a href={youtube}><i className="fa fa-youtube" aria-hidden="true"></i></a>
                  </li> : null
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Contact;
